// import { apiUrl, appRootPathPrefix, apiBaseUrlPath } from '../../../config';
import { session } from '../../../config'
import { identityServices } from '../../common'

let options = {}
options.urlItemName = 'CaseValue'
class ReportsServiceModel {
	constructor(options) {
		this.urlItemName = options.urlItemName
		this.apiUrl = (options && options.apiUrl) || sessionStorage.getItem('apiUrl') || localStorage.getItem('apiUrl')
		this.apiHostUrl = options && options.apiModuleUrl ? `${this.apiUrl}/${options.apiModuleUrl}` : this.apiUrl
	}

	getStdReport = (tenantId, reportName, startDate, endDate, username, fileName, notes,statusFilterValue,queueFilterValue,filteredDomain,itemType) => {
		let apiUrl = this.apiHostUrl || session.get('apiUrl') || sessionStorage.getItem('apiUrl') || localStorage.getItem('apiUrl')
		let ep = `${apiUrl}/ticketing`
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', clientApp: window.location.pathname.split('/')[1] ,itemType : itemType || 'default'},
			url: `${ep}/${this.urlItemName}/report`,
			data: { reportName, download: true, reportQueryPayload: { startDate, endDate, username, fileName,statusFilterValue,queueFilterValue,filteredDomain, type: notes } },
		}
		// @ts-ignore
		return identityServices.identityApi.request(requestOptions).then(response => {
			if (response.status !== 200) {
				return Promise.reject(response)
			}

			return response.data || response
		})
	}
}
export const reportsServices = new ReportsServiceModel(options)
